<template>
  <section>
    <qx-search-box
      class="searchBox"
      ref="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
      :customSub="true"
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        form: [
          { // 原司机
            label: '原司机',
            value: 'formerUserName',
            type: 'input',
            placeholder: '请输入原司机',
          },
          { // 接收司机
            label: '接收司机',
            value: 'receiveUserName',
            type: 'input',
            placeholder: '请输入接收司机',
          },
          { // 发起人
            label: '发起人',
            value: 'originUserName',
            type: 'input',
            placeholder: '请输入发起人',
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      this.$refs.tableBox.saveSearchBoxData({
        state: -1,
        orderId: this.$route.query.id,
        ...searchBoxData,
      });
    },
    getData () {
      this.$refs.searchBox.sub();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
